import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";

@Component({
    selector: 'app-vertical-sh-com-ratings',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './vertical-sh-com-ratings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './vertical-sh-com-ratings.component.css'
})
export class VerticalShComRatingsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  modelSelection!: GuruEntity;
  sizeSelection!: GuruEntity;
  chassisStyleSelection!: GuruEntity;
  unitVoltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  drainPanOptionsSelection!: GuruEntity;
  autoFlowRegulatorSelection!: GuruEntity;
  controlOptionsSelection!: GuruEntity;
  waterCircuitSelection!: GuruEntity;
  heatExchangerOptionsSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.RATINGS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.modelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USModel');
    this.sizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSize');
    this.chassisStyleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCHSStyle');
    this.unitVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCHSVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USMotorControl');
    this.drainPanOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USDrainPan');
    this.autoFlowRegulatorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFlowCntl');
    this.controlOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlOptions');
    this.waterCircuitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterCircuitOptions');
    this.heatExchangerOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHeatExchangerOptions');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
